module.exports = __webpack_public_path__ + "img/1.fd1df2c0.jpg";